import { useEffect, useState } from "react";
import Button from "@/components/Button";
import Column from "@/components/Column";
import Columns from "@/components/Columns";
import Footer from "@/components/Footer";
import TopBar from "@/components/TopBar";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import Input from "@/components/Input";
import { useFormStore } from "@/store/form";

import Form from "@/components/Form";
import * as yup from "yup";
import { ProductsFetch } from "@/api/products";
import { useActiveStore } from "@/store/activePages";
import { useProductStore } from "@/store/product";
import { usePhoneBlockSaleStore } from "@/store/phoneBlock";
import { TargetedOfferFetch } from "@/api/targetedOffer/targetedOffer";
import { setMarketingInfo } from "@/utils/saleSessionStorage";
import { useNavigate, useSearchParams } from "react-router-dom";

const personalDataSchema = yup.object().shape({
  tel: yup.string().tel().required("O telefone é obrigatório"),
});

export const SmartPage = () => {
  const { data: products } = ProductsFetch();
  const form = useFormStore((store) => store.value);
  const addData = useFormStore((store) => store.addData);
  const addPage = useActiveStore((store) => store.addPage);
  const setProduct = useProductStore((store) => store.setProduct);
  const setPhoneBlock = usePhoneBlockSaleStore((store) => store.setPhoneBlock);

  const [telValid, setTelValid] = useState("");
  const [tel, setTel] = useState(form.tel);
  const [formIsValid, setFormIsValid] = useState(false);

  const navigate = useNavigate();

  const { data: offer } = TargetedOfferFetch(telValid);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams) {
      const search: { [key: string]: string } = {};
      searchParams.forEach((value, key) => {
        search[key] = value;
      });
      if (search.utm_source) {
        setMarketingInfo(search);
      }
      addData(search);
    }
  }, [addData, searchParams]);

  useEffect(() => {
    addData({ tel });
  }, [tel, addData]);

  useEffect(() => {
    personalDataSchema
      .isValid({
        tel,
      })
      .then((isValid) => {
        if (isValid) {
          setTelValid(tel.replace(/[\s-]/g, ""));
        }
        if (offer) {
          setFormIsValid(isValid);
        }
      })
      .catch(() => {
        setFormIsValid(false);
      });
  }, [addPage, offer, products, navigate, setPhoneBlock, setProduct, tel]);

  const handleProductSelect = () => {
    const findPlan = products?.find((product) => product.tim_id === offer);

    if (findPlan) {
      setProduct(findPlan);
      addPage("/personal-data");
      navigate("/personal-data");
      setPhoneBlock(true);
    }
    addPage("/personal-data");
  };

  return (
    <div>
      <SEO
        title="Descubra o Plano Ideal"
        description="Parabéns! Você está prestes a ativar o plano perfeito para você."
      />

      <TopBar />

      <Columns
        className="flex min-h-screen max-w-full flex-col items-center pb-4 lg:p-4"
        useNegativeMargin={false}
      >
        <Column size={[12, 12, 5]}>
          <div className="mt-4 flex flex-col">
            <div className="ml-2">
              <PageHeader
                title="Olá! Preencha o campo a seguir e a TIM irá oferecer um plano
            de celular perfeito para você! "
                dataIcTitle="sec-omega-comunicacao"
              />
            </div>
            <Column
              as={Form}
              className="pt-6"
              validationSchema={personalDataSchema}
            >
              <Input
                mask="99 99999-9999"
                name="tel"
                type="tel"
                value={tel}
                label="Número de telefone"
                placeholder="11 99999-9999"
                onChange={(e) => setTel(e.target.value)}
              />
            </Column>

            <Column size={[12]} className="mx-auto pb-8 text-center">
              <Button
                type="button"
                className="tim-soft-blue mt-6 text-base font-bold"
                large
                disabled={!formIsValid}
                to="/personal-data"
                onClick={() => handleProductSelect()}
              >
                QUERO MEU PLANO
              </Button>
            </Column>
            <Column size={12} className="mt-4">
              <Button
                type="button"
                kind="secondary"
                large
                to="/"
                data-ic-trigger="sec-omega-voltar"
              >
                Voltar
              </Button>
            </Column>
          </div>
        </Column>
      </Columns>
      <Column className="absolute bottom-0 left-0 right-0 mb-4">
        <Footer showText />
      </Column>
    </div>
  );
};

export default SmartPage;
